import apiClient from '../../lib/axios';

export const fetchFundCommitments = async ({
  page = 1,
  pageSize = 10,
  project,
  partner,
} = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (project) params.append('project', project);
  if (partner) params.append('partner', partner);
  const { data } = await apiClient.get(`/api/fund-commitments?${params.toString()}`);
  return data;
};

export const fetchActiveFundCommitments = async () => {
  const { data } = await apiClient.get('/api/fund-commitments/active');
  return data;
};

export const fetchFundCommitmentById = async (id) => {
  const { data } = await apiClient.get(`/api/fund-commitments/${id}`);
  return data;
};

export const createFundCommitment = async (payload) => {
  const { data } = await apiClient.post('/api/fund-commitments', payload);
  return data;
};

export const updateFundCommitment = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/fund-commitments/${id}`, payload);
  return data;
};

export const deleteFundCommitment = async (id) => {
  const { data } = await apiClient.delete(`/api/fund-commitments/${id}`);
  return data;
};

export default fetchFundCommitments;
